module.exports = __webpack_public_path__ + "img/study_icon_light@2x.5bd848d8.png";